import { createSelector } from 'reselect';
import { RootState } from 'reducers/rootReducer';

const getIsMobileScreen = (state: RootState) => state.mobileReducer.isMobileScreen;
const isMobileScreen = createSelector(getIsMobileScreen, (res) => res);

export const mobileSelector = { isMobileScreen };
